import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { MasterPatientsCareService } from 'src/app/patients-care/Service/master-patients-care.service';

@Component({
  selector: 'app-prescription-body',
  templateUrl: './prescription-body.component.html',
  styleUrls: ['./prescription-body.component.css']
})
export class PrescriptionBodyComponent {
  location: string = "";
  opddata: any;
  inistialscreendata: any;
  condata: any;
  constructor(private masterservice: MasterPatientsCareService, ) { }
  ngOnInit(): void {
    this.location = "https://www.google.com/maps/search/?api=1&query=";
    const data = JSON.parse(sessionStorage.getItem('myData'));
    console.log(data);
    this.opddata = data.OpnNo;
    console.log(this.opddata)
    this.inistialscreendata = data.UPRNdata;
    console.log(this.inistialscreendata);
    this.masterservice.DrConcView({ 'btn_name': 'VIEWOPDTICKETREGISTRATION', 'patientTicketRegistrationOpdId':  this.opddata.patientTicketRegistrationOpdId  }).subscribe((response) => {
      
      this.condata = response[0];
      console.log("consulation data",this.condata);
    });
    
  }
  
  doPrintt(printThis: string) {
   
    window.print();
  }
}
